import { createContext, useContext, useState, useCallback } from "react";
import Icon from "../components/Icon";

const ToastCtx = createContext(null);
let idSeq = 1;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((message, type = "info", durationMs = 5000) => {
    const id = idSeq++;
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), Math.max(1500, durationMs));
  }, []);

  const remove = (id) => setToasts((t) => t.filter((x) => x.id !== id));

  const color = {
    info: "border-brand-300 bg-brand-50 text-brand-800",
    success: "border-emerald-300 bg-emerald-50 text-emerald-800",
    warning: "border-amber-300 bg-amber-50 text-amber-800",
    error: "border-rose-300 bg-rose-50 text-rose-800",
  };

  return (
    <ToastCtx.Provider value={{ push }}>
      {children}
      {/* z por encima del modal (z-50) y su backdrop-blur: si no, el aviso de
          error quedaba detrás y difuminado, ilegible. Pedido 2026-09-20. */}
      <div className="fixed bottom-4 right-4 z-[100] flex w-80 flex-col gap-2">
        {toasts.map((t) => (
          <div key={t.id} className={`card flex items-start gap-2 border px-4 py-3 text-sm ${color[t.type]}`}>
            <span className="flex-1">{t.message}</span>
            <button onClick={() => remove(t.id)} className="opacity-60 hover:opacity-100"><Icon name="x" size={14} /></button>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
